<template>
  <div class="view-digitalmanagerguru">
    <h4 class="text-semibold mb-5">Digital Manager Guru</h4>
    <snow-data-table-header
      class="mb-6"
      @add="add"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <snow-data-table
        :data="integrationList"
        :columns="digitalManagerGuruColumns"
      >
        <template #url="{ item }">
          <div class="d-flex">
            <snow-button variant="borderless" size="sm" @click="copyUrl(item)">
              <i class="ph ph-link" />
            </snow-button>
            <snow-button variant="borderless" size="sm" @click="openUrl(item)">
              <i class="ph ph-arrow-square-out" />
            </snow-button>
          </div>
        </template>
        <template #no-content-actions>
          <snow-button
            icon="ph ph-plus"
            text="Adicionar integração"
            @click="modal = true"
          />
        </template>
      </snow-data-table>
      <div class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </template>

    <DigitalManagerGuru
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @close="modal = false"
      @update-list="dispatch"
    />
  </div>
</template>
<script>
import DigitalManagerGuru from "@/components/tools/modals/DigitalManagerGuru.vue";
import IntegrationsMixin from "@/mixins/integration.js";

export default {
  mixins: [IntegrationsMixin],
  components: {
    DigitalManagerGuru
  },
  data() {
    return {
      integration: "digital-manager-guru",
      breadcrumbs: [
        { title: "Ferramentas", link: "tools" },
        { title: "Automações", link: "tools-automations" },
        { title: "Digital Manager Guru" }
      ]
    };
  },
  computed: {
    digitalManagerGuruColumns() {
      return [
        {
          name: "Produto",
          field: "product_name"
        },
        {
          name: "Descrição",
          field: "description",
          transform: v => this.formatLongText(v)
        },
        {
          name: "Token",
          field: "token"
        },
        {
          name: "ID externo",
          field: "internal_id"
        },
        {
          name: "URL externo",
          field: "url"
        },
        {
          name: "Status",
          field: "status",
          transform: v => (v ? "Ativo" : "Inativo"),
          color: v => (v ? "green" : "negative"),
          type: "tag"
        },
        {
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  methods: {
    getActions(item) {
      return [
        {
          label: item.status ? "Desativar" : "Ativar",
          click: this.changeStatus
        },
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Deseja mesmo excluir esta integração?",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            secondaryButtonText: "Não, cancelar",
            action: this.submitDelete
          }
        }
      ];
    }
  }
};
</script>
